var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseNumericTag',{attrs:{"value":_vm.value}}),_c('span',[_vm._v(_vm._s(_vm.day))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }